export default __webpack_public_path__ + "static/media/site_type.788477b8.svg";